import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <img
              src="/images/logo.png"
              alt="Teen Challenge Armenia"
            />
            <p>
              Teen Challenge Armenia is a faith-based 501(c)(3) non-profit organization bringing hope, healing, and Christ-centered transformation to individuals and families in Armenia.
            </p>
          </div>

          <div>
            <h4>Quick Links</h4>
            <div className="footer-links">
              <Link to="/">Home</Link>
              <Link to="/about">About Us</Link>
              <Link to="/mens-rehabilitation-center">Men's Rehab Center</Link>
              <Link to="/orphanage-ministry">Orphanage Ministry</Link>
              <Link to="/testimonies">Testimonies</Link>
              <Link to="/gallery">Gallery</Link>
              <Link to="/contact">Contact</Link>
              <Link to="/donate">Donate</Link>
            </div>
          </div>

          <div className="footer-contact">
            <h4>Contact</h4>
            <p>In US: <a href="tel:+15596688807">+1 (559) 668-8807</a></p>
            <p>In Armenia: <a href="tel:+37455677888">+374 55 677888</a></p>
            <p>Email: <a href="mailto:contact@teenchallengearmenia.org">contact@teenchallengearmenia.org</a></p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>Copyright {new Date().getFullYear()} Teen Challenge Armenia | All Rights Reserved</p>
          <a
            href="https://softangeles.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', marginTop: '14px', opacity: 0.9, fontSize: '15px', fontWeight: 500, textDecoration: 'none', color: '#ffffff' }}
          >
            <span>Powered by</span>
            <img src="https://softangeles.com/logo-wide.png" alt="SoftAngeles" style={{ height: '30px', width: 'auto' }} />
          </a>
          <div className="footer-socials">
            <a href="https://www.facebook.com/TeenChallengeArmenia/" target="_blank" rel="noopener noreferrer">Facebook</a>
            <a href="https://www.youtube.com/@teenchallengearmenia852" target="_blank" rel="noopener noreferrer">YouTube</a>
            <a href="https://www.instagram.com/teenchallengearmenia/" target="_blank" rel="noopener noreferrer">Instagram</a>
            <a href="https://www.linkedin.com/company/teenchallengearmenia" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
